import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const StartSessionRequest = z.object({
  location: z.string(),
  lang: z.string(),
  // TODO(roman): pass enabled features and/or mode
})

export type StartSessionRequest = z.infer<typeof StartSessionRequest>

export const StartSessionResponse = z.object({
  clientUserId: z.string(),
  agentId: z.string(), // TODO(roman): reconsider, maybe can be retired
  vfProjectId: z.string(),
})

export type StartSessionResponse = z.infer<typeof StartSessionResponse>

export const startSessionDeclaration = endpointDeclaration(StartSessionRequest, StartSessionResponse)
